import { FormCentralizer } from '@/components';
import { useId } from '@/hooks';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useResetPassword } from '../../hooks';
import { ResetPasswordForm } from './ResetPasswordForm';

export const ResetPasswordPage: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openMessage } = useMessage();
  const { id } = useId();
  const { mutateAsync: resetPassword } = useResetPassword();

  return (
    <FormCentralizer>
      <ResetPasswordForm
        onSubmit={async (values) => {
          const { confirmPassword, ...payload } = values;
          try {
            await resetPassword({ id, ...payload });

            await Promise.all([
              openMessage('success', t('message-save-completed')),
              (async () => {
                navigate(`/tenant-manager/users/${id}`, { replace: true });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-save-failed'));
          }
        }}
      />
    </FormCentralizer>
  );
};
